import ErrorComponent from "@/components/atoms/ErrorComponent";
import UserHeader from "@/components/molecules/card-headers/UserHeader";
import UserCommissionsCard from "@/components/molecules/cards/users/UserCommissionsCard";
import UserEditCard from "@/components/molecules/cards/users/UserEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const UserEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }
  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <UserHeader id={id} isEdit />
      <UserEditCard id={id} />
      <UserCommissionsCard id={id} />
    </div>
  );
};

export default UserEditView;
